<span class="flex flex-column">
  <span class="form__field" *ngFor="let text of splitted">
    <span *ngIf="!isEmail && !isPhone">
      {{text}}
    </span>
    <a *ngIf="isEmail && !isPhone" href="mailto:{{text}}">
      {{text}}
    </a>
    <a *ngIf="!isEmail && isPhone" href="tel:{{text}}">
      {{text}}
    </a>
  </span>
</span>